import { useMemo } from 'react';
import appRoutes from '~/appRoutes';
import { type DashboardTab, useDashboardTabs } from '~/hooks/useDashboardTabs';
import { FEATURE_FLAGS, useFeatureFlagEnabledByDefault } from '~/hooks/useFeatureFlag';
import { useFormatMessage } from '~/intl';

export function useAllocatedVolumesTab() {
  const formatMessage = useFormatMessage();
  const allocationsPivotTableEnabled = useFeatureFlagEnabledByDefault(FEATURE_FLAGS.allocations_pivot_table_enabled);

  const tabs = useMemo<DashboardTab[]>(
    () => [
      {
        icon: 'ListCheckIcon',
        id: 'custom-views',
        disabled: !allocationsPivotTableEnabled,
        isDynamicRoute: true,
        label: formatMessage({ id: 'allocations.shared.batches.tabsAll' }),
        route: appRoutes.ALLOCATIONS_CUSTOM_VIEWS(),
        tooltip: allocationsPivotTableEnabled ? undefined : 'Disabled for this organisation',
      },
      {
        icon: 'Archive2LineIcon',
        id: 'batches',
        label: formatMessage({ id: 'allocations.shared.batches.tabsBatches' }),
        route: appRoutes.ALLOCATIONS_BATCHES,
      },
    ],
    [allocationsPivotTableEnabled, formatMessage],
  );

  return useDashboardTabs(tabs, {
    disabledTabValues: ['pending', 'finalised'],
    storageDefaultValue: 'custom-views',
    storageKey: 'allocated-volumes-custom-views.tab',
  });
}
